exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uld-banner{position:fixed;top:0;left:0;z-index:10000;width:100%;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;color:#fff;line-height:1.43;background:#565656;padding-bottom:20px}.uld-banner .uld-container{display:flex;justify-content:space-around;flex-wrap:wrap;text-align:center}.uld-banner button{background:rgba(86,86,86,.95);margin:0 10px;border:3px solid #fff;padding:9px 12px;text-transform:uppercase}.medscape-mobile .uld-banner{font-size:12px;padding-bottom:10px}.medscape-mobile .uld-banner .content{padding:10px}.show-gdpr .isgdprct header{margin-top:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./medscape_modules/uld/styles.scss
// module id = 640
// module chunks = 0